import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { handleClickEditPerson } from 'components/views/FounderTeam/_helpers/founderTeam.events';
import { $view } from 'signals/global.signals';

const FounderPersonRows = ({ data }) => data.map((person) => ({
  ...person,
  id: person.id,
  firstName: person.firstName,
  lastName: person.lastName,
  name: `${person.firstName} ${person.lastName}`,
  email: person.email,
  roles: person.roles,
  teams: person.teams,
  Roles: $view.value.roleOptions
    ?.filter((option) => person.roles?.includes(option.value))
    .map((option) => option.label)
    .join(', '),
  Teams: $view.value.teamOptions
    ?.filter((option) => person.teams?.includes(option.value))
    .map((option) => option.label)
    .join(', '),
  Actions: (
    <ContextMenu
      menuItems={[
        {
          label: 'Edit',
          onClick: () => handleClickEditPerson(person),
        },
        {
          label: 'Delete',
          onClick: () => handleShowModal('delete-person', { id: person.id, firstName: person.firstName, lastName: person.lastName }),
        },
      ]}
    />
  ),
}));

export default FounderPersonRows;
